module.exports = __webpack_public_path__ + "static/media/ft-reviews.8c75c25f.svg";